import { useState, useEffect, useRef } from "react"
import { gsap } from "gsap";

import arrow_right from "../../../assets/icons/arrow_right.svg"
import styles from "../../../assets/stylesheets/sass/Filter.module.scss";

export default function Sort({system, data, returnedArray}){

    useEffect(()=>{
        setSelectedValue(Object.keys(system.options)[0])
    }, [])

    //States
    const [showOptions, setShowOptions] = useState(false);
    const [selectedValue, setSelectedValue] = useState("");

    //Refs
    const defaultvalDiv = useRef(null);
    const optionsDiv = useRef(null);

    const showOptionsAnimation = () => {
        gsap.to(defaultvalDiv.current, {x:-100, opacity:0, duration:.2, maxHeight:"10rem", onComplete:function(){
            setShowOptions(true)
            gsap.to(optionsDiv.current, {x:0, opacity:1, duration:.2})
        }})
        
    }

    const showDefaultAnimation = () => {
        gsap.to(optionsDiv.current, {x:optionsDiv.current.offsetWidth, opacity:0, duration:.2, onComplete:function(){
            setShowOptions(false)
            gsap.to(defaultvalDiv.current, {x:0, opacity:1, duration:.2, maxHeight:"10rem"})
        }})
    }

    const sortData = (label, key) => {
        showDefaultAnimation();
        setSelectedValue(label);

        const arr = [...data];

        if(key.substring(0,2) === "dt"){
            arr.sort((a,b) => new Date(b[key]) - new Date(a[key]));
        }
        else {
            arr.sort((a,b) => b[key] - a[key]);
        }

        

        returnedArray(arr);
    }

    return (
        <>
        <div className={styles.sort_container}>
            
            {!showOptions ? 
            <div className={styles.sort_defvalue} onClick={()=>showOptionsAnimation()} ref={defaultvalDiv}>
                <p>{selectedValue}</p>
                <img src={arrow_right} alt="arrow"/>
            </div>
            :
            <i className={styles.sort_options} ref={optionsDiv}>
                <button className={styles.backbutton} onClick={()=>{showDefaultAnimation()}}>Terug</button>
                <div className={styles.sort_option_buttons}>
                {Object.keys(system.options).map((v, i)=>{
                    return (
                        <button className={styles.sort_button} key={i} onClick={()=>{sortData(v, system.options[v])}}>{v}</button>
                    )
                })}
                </div>
            </i>
            }
        </div>
        </>
    )
}